import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LicenseManager } from 'ag-grid-enterprise';

import Notification from 'components/Notification';
import CustomNotification from 'components/CustomNotification';
import PreLoaderWidget from 'components/Loader';

import Routes from 'routes';
import store from 'store';

const loadLicense = () => {
    LicenseManager.setLicenseKey(process.env.AG_GRID_ENTERPRISE_KEY);
};

loadLicense();

const Root = () => (
    <Provider store={store}>
        <BrowserRouter basename="/recon">
            <Notification />
            <CustomNotification />
            <PreLoaderWidget />
            <Routes />
        </BrowserRouter>
    </Provider>
);

export default Root;
